export default Object.freeze({
  NEW: 'Nouveau',
  VALIDATED: 'Actif',
  REFUSED: 'Refusé',
});
